(ns pfo.widget.progressbar
  (:require [reagent.core :as reagent :refer [atom]]))


(def new-progress {:active? false
                   :stage nil
                   :label "Initializing..."
                   :current 0
                   :total 0
                   :percent 0})

(defonce global-progress (atom new-progress))

;; The active EventSource, so an in-flight connection can be cancelled explicitly
;; instead of leaking when the user navigates away mid-progress (#2884).
(defonce current-event-source (clojure.core/atom nil))

(defn stop-progress-listener
  "Closes the active progress EventSource, if any, and resets the progress state.
   Safe to call when no listener is active."
  []
  (when-let [es @current-event-source]
    (.close es)
    (reset! current-event-source nil))
  (reset! global-progress new-progress))

(defn start-progress-listener [url token]
  (stop-progress-listener)
  (swap! global-progress assoc :active? true)
  (let [es (js/EventSource. (str js/API_BASE_URL url "?token=" token))]
    (reset! current-event-source es)
    (.addEventListener es "message"
                       (fn [event]
                         (let [data (js->clj (js/JSON.parse (.-data event)) :keywordize-keys true)]
                           (reset! global-progress {:active?  true
                                                    :stage    (:stage data)
                                                    :label    (:label data)
                                                    :current  (:current data)
                                                    :total    (:total data)
                                                    :percent  (:percent data)}))))
    (.addEventListener es "done"
                       (fn [_]
                         (.close es)
                         (reset! current-event-source nil)
                         (reset! global-progress new-progress)))
    (set! (.-onerror es)
          (fn []
            (.close es)
            (reset! current-event-source nil)
            (reset! global-progress new-progress)))))

(defn progress-bar []
  (let [{:keys [active? stage label percent current total]} @global-progress]
    (when active?
      [:div.progress-container
       [:div.status-row
        [:strong (case stage
                   "PREPARING" "Preparing"
                   "DELETING"  "Deleting"
                   "FINISHED"  "Finished"
                   "Processing...")]
        [:span (str current " / " total)]]
       [:div.label-text label]
       [:div.progress-track
        [:div.progress-fill {:class (when (= stage "DELETING") "deleting")
                             :style {:width (str percent "%")}}]]])))
